/* istanbul ignore file */
/**
 * Created by rathompson on 11/8/21
 * File: Pill
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { VFC, useState } from 'react'
import PropTypes from 'prop-types'
import { classNames } from '@panwds/react-ui'
import { CloseIcon } from '@panwds/icons'

/**
 *   Pill component
 */
const makeClassName = (props: { appearance: string, addClassName: string, selected: boolean, selectable: boolean }) => {

  const { appearance, addClassName, selected, selectable } = props
  const defaultClassNames = 'tw-flex tw-flex-row tw-border tw-py-0.5 tw-px-2 tw-border-solid tw-rounded-full tw-w-max tw-items-center'

  const typeClassName = {
    'primary': classNames('tw-border-green tw-bg-green tw-text-dark-bg'),
    'secondary': classNames('tw-border-green'),
    'primary-destructive': classNames('tw-border-red tw-bg-red tw-text-dark-bg'),
    'secondary-destructive': classNames('tw-border-red'),
    'tertiary': classNames('tw-border-gray-300')
  } as { [key: string]: string }

  return classNames(
    addClassName,
    defaultClassNames,
    typeClassName[appearance],
    selectable ? (selected ? 'tw-cursor-pointer tw-bg-blue-200 tw-border-blue' : 'tw-cursor-pointer hover:tw-bg-blue-100') : ''
  )
}

const Pill: VFC<any> = ({
  children,
  appearance,
  icon,
  removable,
  button,
  onClick,
  addClassName,
  disabled,
  selectable,
  onDelete,
}) => {
  const [selected, setSelected] = useState(false)
  const className = makeClassName({ appearance, addClassName, selected, selectable })
  const sizeCls = 'cm-w-[20px] cm-h-[20px]'
  return (
    <span {...{ className }} onClick={() => {
      if (selectable) {
        setSelected(!selected)
      }
    }}>
      {icon && (
        <span
          className={classNames(sizeCls, 'tw-grid tw-justify-items-center',
            appearance === 'primary' && 'tw-text-dark-bg',
            appearance === 'secondary' && disabled ? 'tw-text-disabled' : 'tw-text-link',
          )}
        >{icon}</span>
      )}
      {children}
      {removable && (button ? button : (
        <span className={classNames(
          sizeCls,
          'tw-grid tw-items-center tw-justify-items-center tw-cursor-pointer hover:tw-bg-blue-200 tw-rounded-full',
          (appearance === 'primary' || appearance === 'primary-destructive') ? 'tw-text-dark-bg hover:tw-text-default' :
            appearance === 'tertiary' ? 'tw-text-gray-600' : '',
        )} onClick={onDelete}>
          <CloseIcon size='xs' />
        </span>
      ))}
    </span>
  )
}

Pill.propTypes = {
  appearance: PropTypes.oneOf([
    'primary',
    'primary-destructive',
    'secondary',
    'secondary-destructive',
    'tertiary'
  ]),
  addClassName: PropTypes.string
}

Pill.defaultProps = {
  appearance: 'secondary',
}

export default Pill
